module.exports = __webpack_public_path__ + "static/media/registration_success.f10844aa.jpg";